
export const getTranslation = (translations, locale, key, backup = null) => {
  if (!translations) return backup;
  if (!translations[key]) return backup;
  const find = translations[key].find((item) => item.locale === locale);
  if (!find) return backup;
  const found = find ? find.text : null;
  if (!found) return backup;
  return found;
};

export const updateTranslation = (translations, locale, key, value) => {
  const copy = { ...(translations ?? {}) };
  const items = [...(copy[key] ?? [])];
  const index = items.findIndex((item) => item.locale === locale);

  if (index > -1) {
    items.splice(index, 1, { ...items[index], text: value });
  } else {
    items.push({ locale, text: value });
  }

  copy[key] = items;
  return copy;
};
